export class CredentialModel {
  Id?: number;
  Name?: string;
  Type?: CredentialType;
  Username: string;
  Password: string;
  Domain?: string;
}

export enum CredentialType {
  Camera = 1,
  Server = 2,
}
